import React from 'react';

interface ErrorBadgeProps {
  count: number;
  className?: string;
}

export const ErrorBadge: React.FC<ErrorBadgeProps> = ({ count, className = '' }) => {
  if (count === 0) return null;

  return (
    <div 
      className={`error-badge-supabase ${className}`}
      title={`${count} validation error${count > 1 ? 's' : ''}`}
    >
      {count}
    </div>
  );
};
